import { useEffect, useState } from 'react';

export function useDeviceInfo() {
  const mobileQuery = '(max-width: 767px)';
  const laptopQuery = '(min-width: 1024px)';
  const tabletQuery = '(min-width: 768px) and (max-width: 1023px)';

  const laptopMediaQueryList = window.matchMedia(laptopQuery);
  const tabletMediaQueryList = window.matchMedia(tabletQuery);
  const mobileMediaQueryList = window.matchMedia(mobileQuery);

  const getDeviceType = () => {
    if (laptopMediaQueryList.matches) {
      return 'laptop';
    } else if (tabletMediaQueryList.matches) {
      return 'tablet';
    } else if (mobileMediaQueryList.matches) {
      return 'mobile';
    }
  };

  const [deviceType, setDeviceType] = useState(getDeviceType());

  useEffect(() => {
    const updateDeviceType = () => {
      setDeviceType(getDeviceType());
    };

    laptopMediaQueryList.addEventListener('change', updateDeviceType);
    tabletMediaQueryList.addEventListener('change', updateDeviceType);
    mobileMediaQueryList.addEventListener('change', updateDeviceType);

    updateDeviceType();

    return () => {
      laptopMediaQueryList.removeEventListener('change', updateDeviceType);
      tabletMediaQueryList.removeEventListener('change', updateDeviceType);
      mobileMediaQueryList.removeEventListener('change', updateDeviceType);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    deviceType,
  };
}
